window.addEventListener("load", function () {
  var slider = document.querySelector('[data-recently-count="6"]');

  if (slider) {
    slider.style.display = "flex"; 

    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      draggable: true,
      resize: true,
    });
  }
});